var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14h6v6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10h-6V4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10l7-7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21l7-7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsClosed);
export default __webpack_public_path__ + "static/media/arrows-closed.7139f5de1d2f339b026866c3677175b5.svg";
export { ForwardRef as ReactComponent };